import React, { Suspense } from 'react';

const LoadableComponent = React.lazy(() => import('./Dashboard'));

function LoadableDashboard() {
  return (
    <Suspense fallback={<div />}>
      <LoadableComponent />
    </Suspense>
  );
}

export default LoadableDashboard;
